import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@repo/videa-components/src/ui/select';

import type { PromptOption } from '../types/api';

interface PromptSelectProps {
  promptOptions: PromptOption[];
  selectedPrompt: string | undefined;
  onSelectedPrompt: (value: string | undefined) => void;
}

const PromptSelect = ({
  promptOptions,
  selectedPrompt,
  onSelectedPrompt,
}: PromptSelectProps) => {
  return (
    <>
      <Select defaultValue={selectedPrompt} onValueChange={onSelectedPrompt}>
        <SelectTrigger>
          <SelectValue placeholder="Select a template" />
        </SelectTrigger>
        <SelectContent className="vai-overflow-visible vai-z-[10001]">
          {promptOptions.map((option) => {
            return (
              <SelectItem key={option.name} value={option.name}>
                {option.ui_label}
              </SelectItem>
            );
          })}
        </SelectContent>
      </Select>
    </>
  );
};

export default PromptSelect;
